// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"cd0a8c2f","container":"a7b1db50"};